import { getAxiosInstance } from '../configs/axios-config';
import { authDetails } from '../helpers/auth-details';
var constants = require("../configs/constants");

const CHANGE_PASS_PROGRESS = "CHANGE_PASS_PROGRESS";
const CHANGE_PASS_SUCCESS = "CHANGE_PASS_SUCCESS";
const CHANGE_PASS_FAILURE = "CHANGE_PASS_FAILURE";
const CHANGE_PASS_SNACKBAR = "CHANGE_PASS_SNACKBAR";

export const hideSnackBarAction = () => { return { type: CHANGE_PASS_SNACKBAR } }
export const changePassInProgress = (aboutUsData) => { return { type: CHANGE_PASS_PROGRESS, aboutUsData: aboutUsData } }
export const changePassSuccess = (successMessage) => { return { type: CHANGE_PASS_SUCCESS, message: successMessage } }
export const changePassFailure = (errorMessage) => { return { type: CHANGE_PASS_FAILURE, message: errorMessage } }

// HIDE THE MESSAGE SNACKBAR
export const hideSnackBar = () => (dispatch) => {
    dispatch(hideSnackBarAction());
}

/**
 * Save the change password Details
 * @param {object}
 */
export const changePassword = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    dispatch(changePassInProgress());
    return axiosInstance.put(constants.api.CHANGE_PASS, {
        password: data.password,
        mobileNo: user.mobileNo,
    }).then(function (response) {
        dispatch(changePassSuccess("नवीन पासवर्ड जतन केला"));
    }).catch(function (error) {
        dispatch(changePassFailure("नवीन पासवर्ड जतन केला नाही"));
    });
};

export const initialState = {
    inProgress: false,
    message: '',
    open: false,
    change: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_PASS_PROGRESS:
            return { ...state, inProgress: true };
        case CHANGE_PASS_SUCCESS:
            return { ...state, message: action.message, change: true, inProgress: false, open: true };
        case CHANGE_PASS_FAILURE:
            return { ...state, message: action.message, inProgress: false, open: true };
        case CHANGE_PASS_SNACKBAR:
            return { ...state, open: false };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/change-pass-reducer.js